var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoudspeaker28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6019 4.4563C27.0188 3.84906 28.6195 4.31541 29.1152 5.77507C29.6957 7.48431 30.2856 10.2213 30.2856 14.2857C30.2856 18.3567 29.6938 21.2439 29.1124 23.0979C28.6179 24.6749 26.8977 25.2419 25.3786 24.5908L18.0779 21.462C16.8173 20.9217 15.9999 19.6822 15.9999 18.3106V10.8322C15.9999 9.46069 16.8173 8.22113 18.0779 7.68086L25.6019 4.4563Z",
    fill: "url(#paint0_linear_12038_9314)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.43359 14.8571C1.43359 11.7012 3.99197 9.14286 7.14788 9.14286H10.9802C11.859 9.14286 12.5713 9.85522 12.5713 10.734V18.1527C12.5713 19.4195 12.6121 20.4533 12.9493 21.7116L14.4885 27.4562C14.7336 28.3707 14.1909 29.3107 13.2764 29.5558C10.8014 30.219 9.68494 30.0618 9.02634 27.6038L7.48211 21.8407C7.28146 21.0919 6.59394 20.5977 5.83913 20.4209C3.31395 19.8292 1.43359 17.5627 1.43359 14.8571Z",
    fill: "url(#paint1_linear_12038_9314)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12038_9314",
    x1: 1.43359,
    y1: 4.19685,
    x2: 26.9572,
    y2: 32.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12038_9314",
    x1: 1.43359,
    y1: 4.19685,
    x2: 26.9572,
    y2: 32.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoudspeaker28);
export default __webpack_public_path__ + "static/media/loudspeaker_28.8472e7a1.svg";
export { ForwardRef as ReactComponent };